import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { Switch } from './../../models/editors/switch.model';

import { News } from './../../models/news/news.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { atLeastOneLang } from './../../shared/validators/langField.validator';

@Component({
  selector: 'swb-news-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class NewsDetailComponent extends FormDetailBase<News> implements OnInit {

  public url = 'news';
  protected _redirect = './dashboard';

  public entity = new News({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název novinky',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Obsah novinky',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'news-detail'
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Contained({
        key: 'file_id',
        label: 'Náhledový obrázek',
        upload: true,
        entity: this.entity.file
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
